<div class="bc-workitem-list" appTraversableList>
  <ng-container *ifFeatureEnabled="'gc.dxChat'">
    <app-work-item-genesys-chat-list [isHybrid]="isHybrid | async" *gcUserHasAnyPermission="[
        gcUserPermission.ConversationWebMessagingView,
        gcUserPermission.ConversationWebMessagingAccept]"
    ></app-work-item-genesys-chat-list>
  </ng-container>

  <ng-container *ifFeatureEnabled="'gc.dxEmail'">
    <app-work-item-genesys-email-list [isHybrid]="isHybrid | async" *gcUserHasAnyPermission="[gcUserPermission.ConversationEmailAccept]">
    </app-work-item-genesys-email-list>
  </ng-container>

  <ng-container *ngIf='isHybrid | async'>
    <hr/>
  </ng-container>

  <app-work-item-discussion-list [isHybrid]="isHybrid | async" *ngIf="isDiscussionsEnabled"></app-work-item-discussion-list>
  <app-work-item-lens-list [isHybrid]="isHybrid | async" *ngIf="isLensEnabled"></app-work-item-lens-list>
  <app-work-item-chat-list [isHybrid]="isHybrid | async" *ngIf="isChatEnabled"></app-work-item-chat-list>
  <app-work-item-text-chat-list [isHybrid]="isHybrid | async" *ngIf="isSmsEnabled || isFacebookEnabled || isAsyncMessageEnabled"></app-work-item-text-chat-list>
  <app-work-item-email-list [isHybrid]="isHybrid | async" *ngIf="isEmailEnabled"></app-work-item-email-list>
</div>
